import { ValidationLength } from '../constants'

export const isFeeLengthValid = (value?: number): boolean => {
  const wholeNumberAndDecimalParts = value?.toString().split('.')
  const exceedsLength: boolean = wholeNumberAndDecimalParts
    ? wholeNumberAndDecimalParts[0]?.length > ValidationLength.feeInteger || wholeNumberAndDecimalParts[1]?.length > ValidationLength.feeDecimal
    : false
  return !exceedsLength
}
